import { WebGlApp } from './webgl/WebGlApp';
import { SETTINGS } from './webgl/SETTINGS';

const FRAME_INTERVAL = 1000 / SETTINGS.fps; // フレーム間隔

export class AppHandler {
  private WebGlApp: WebGlApp;

  private lastFrameTime: number = 0;

  constructor(
    webglCanvas: HTMLCanvasElement,
  ) {
    // Initialize
    this.WebGlApp = new WebGlApp(webglCanvas);
  }

  /**
   * 初期化
   */
  async initialize(): Promise<void> {
    // Animation開始
    this.animate();
  }

  private animate = (currentTime: number = 0): void => {
    // FPSを制限するための処理
    const deltaTime = currentTime - this.lastFrameTime;
    if (deltaTime >= FRAME_INTERVAL) {
      this.WebGlApp.render();
      this.lastFrameTime = currentTime;
    }
    requestAnimationFrame(this.animate);
  }

  // Helper ------------------------
}